export default "__VITE_ASSET__BEmDLWbi__"